import { Navigate, Link } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import ForcePassword from "@/pages/ForcePassword";

export const FullLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#F4F1EA]" data-testid="app-loading">
    <Loader2 className="h-10 w-10 animate-spin text-[#1E4D2B]" />
  </div>
);

export const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForcePassword />;
  return children;
};

export const RequireModule = ({ id, children }) => {
  const { canAccess } = useAuth();
  if (canAccess(id)) return children;
  return (
    <div className="bg-white border border-[#E2DDD3] rounded-3xl p-8 text-center max-w-lg mx-auto mt-10 fade-up" data-testid="access-denied">
      <ShieldAlert className="h-14 w-14 mx-auto text-[#C86D51]" />
      <h1 className="mt-4 text-3xl font-extrabold">Acesso restrito</h1>
      <p className="mt-2 text-[#5C6B66]">Seu perfil não tem permissão para acessar esta área.</p>
      <Link to="/dashboard" className="mt-6 inline-flex h-12 px-6 items-center rounded-xl bg-[#1E4D2B] text-white font-semibold hover:bg-[#163A20]" data-testid="access-denied-back">Voltar ao início</Link>
    </div>
  );
};
